import script from "./image.vue?vue&type=script&lang=ts&setup=true"
export * from "./image.vue?vue&type=script&lang=ts&setup=true"

import "./image.vue?vue&type=style&index=0&id=7471186c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7471186c"]])

export default __exports__